import { useEffect } from 'react';
import { useWidgetParams } from '../../logic/searchHelper';
import { useNavigate } from 'react-router';
import { useSearchOptions } from '../../contexts/SearchContext';

const WidgetParams = () => {
  const { updateSearchOptions } = useSearchOptions();
  const widgetParams = useWidgetParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (widgetParams) {
      updateSearchOptions(widgetParams);
      if (widgetParams.depg && widgetParams.destg) navigate('/search');
    }
  }, [widgetParams]);

  return null;
};

export default WidgetParams;
